import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TradePairFacade, TradePairState } from '../store/bottradepair';

@Injectable({
    providedIn: 'root'
})
export class GridBotService {
    constructor(
        private http: HttpClient,
        private tradePairFacade: TradePairFacade
    ) { }


    getPairList() {
        return this.http.get(environment.gridBotApiUrl + 'api/bot/tradePair')
    }
    getBotCount(params: any) {
        return this.http.get(environment.gridBotApiUrl + 'api/bot/getBotCount', { params })
    }
    botValidation(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/bot-validation', payload)
    }
    getBotHistory(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/getBotHistory', payload)
    }
    getActiveBotByPair(params: any) {
        return this.http.get(environment.gridBotApiUrl + 'api/bot/getActiveBotByPair', {params})
    }
    getPositionHistory(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/getPositionDetials', payload)
    }
    getOpenOrders(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/getOpenOrders', payload)
    }
    getOrderHistory(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/getOrderHistory', payload)
    }
    closeBot(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/close-bot', payload)
    }
    getOpenOChart(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/getOpenOrdersChart', payload)
    }
    orderPlace(payload: any) {
        return this.http.post(environment.gridBotApiUrl + 'api/bot/orderplace', payload)
    }

    blockBot() {
        return this.http.get(environment.gridBotApiUrl + 'api/bot/get-last-order')
    }

    setTradePair({
        firstCurrencySymbol,
        firstCurrencyId,
        firstFloatDigit,
        secondCurrencySymbol,
        secondCurrencyId,
        secondFloatDigit,
        botstatus,
        tikerRoot,
        _id,
        maker_rebate,
        taker_fees
    }: TradePairState) {
        this.tradePairFacade.setTradePair(
            {
                firstCurrencySymbol,
                firstCurrencyId,
                firstFloatDigit,
                secondCurrencySymbol,
                secondCurrencyId,
                secondFloatDigit,
                botstatus,
                tikerRoot,
                _id,
                maker_rebate,
                taker_fees
            })
    }



}
